import { useCreateUserContext } from '../contexts/CreateUserContext';

export default function useValidateUserFromSchema() {
	const { setUserErrors } = useCreateUserContext();

	const validateFromSchema = (
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		schema: any,
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		data: any,
		_name: string,
	) => {
		schema
			.validate(data)
			.then(() => {
				setUserErrors(_userValid => ({
					..._userValid,
					[_name]: false,
				}));
			})
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			.catch((e: any) => {
				setUserErrors(_userValid => ({
					..._userValid,
					[_name]: e?.errors,
				}));
			});
	};

	return validateFromSchema;
}
